/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import menus from "./menus";
import JumboVerticalNavbar from "@jumbo/components/JumboVerticalNavbar/JumboVerticalNavbar";
import { DrawerHeader } from "@jumbo/components/JumboLayout/style";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import useJumboSidebarTheme from "@jumbo/hooks/useJumboSidebarTheme";
import { SIDEBAR_STYLES, SIDEBAR_VIEWS } from "@jumbo/utils/constants/layout";
import Logo from "../../../../shared/Logo";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Zoom from "@mui/material/Zoom";
import Div from "@jumbo/shared/Div";
import SidebarSkeleton from "./SidebarSkeleton";
import { userType } from "app/helpers/userType";

const Sidebar = () => {
  const { isMA } = userType();
  const [sidebarView, setSidebarView] = useState(menus || []);
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );
  useEffect(() => {
    if (!isMA) {
      // `permission` is "All", one permission name, or a list of names
      // (menu shows when the user has any of them).
      const hasMenuPermission = (permission) =>
        permission === "All" ||
        (permissionData || []).some((perm) =>
          Array.isArray(permission)
            ? permission.includes(perm?.name)
            : perm?.name === permission
        );

      const filteredMenus = menus.filter((menu) => {
        // Filter first level children
        const filteredChildren = menu?.children?.filter((ch) => {
          const hasPermission = hasMenuPermission(ch?.permission);

          // Filter sub-children and check if any have permission
          let hasChildPermission = false;

          if (ch.children) {
            // Filter the sub-children array to only include items with permission
            const filteredSubChildren = ch.children.filter((subCh) =>
              hasMenuPermission(subCh?.permission)
            );

            // Update the children array with filtered results
            ch.children = filteredSubChildren;
            // Check if there are any sub-children with permission
            hasChildPermission = filteredSubChildren.length > 0;
          }

          return hasPermission || hasChildPermission;
        });

        menu.children = filteredChildren;
        return filteredChildren.length > 0;
      });

      setSidebarView(filteredMenus);
    }
  }, [!isMA, permissionData, menus]);

  return (
    <React.Fragment>
      <SidebarHeader />
      <JumboScrollbar autoHide autoHideDuration={200} autoHideTimeout={500}>
        <Suspense
          fallback={
            <Div
              sx={{
                display: "flex",
                minWidth: 0,
                alignItems: "center",
                alignContent: "center",
                px: 3,
              }}
            >
              <SidebarSkeleton />
            </Div>
          }
        >
          <JumboVerticalNavbar translate items={sidebarView} />
        </Suspense>
      </JumboScrollbar>
    </React.Fragment>
  );
};

const SidebarHeader = () => {
  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
  const { sidebarTheme } = useJumboSidebarTheme();

  const isMiniAndClosed = React.useMemo(() => {
    return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
  }, [sidebarOptions.view, sidebarOptions.open]);

  return (
    <React.Fragment>
      {sidebarOptions?.style !== SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && (
        <DrawerHeader>
          <Logo mini={isMiniAndClosed} mode={sidebarTheme.type} />
          {sidebarOptions?.view !== SIDEBAR_VIEWS.MINI && (
            <Zoom in={sidebarOptions?.open}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{ ml: 0, mr: -1.5 }}
                onClick={() => setSidebarOptions({ open: false })}
              >
                <MenuOpenIcon />
              </IconButton>
            </Zoom>
          )}
        </DrawerHeader>
      )}
    </React.Fragment>
  );
};

export default Sidebar;
